import React, { Component } from "react";
import { Field, change } from "redux-form";
import DropdownList from 'react-widgets/lib/DropdownList'
import InputMask from 'react-input-mask';

const divStyle = {
    marginLeft: '0px',
    marginRight: '5px'
};
const divLabelStyle = {
    marginLeft: '20px'
};
const divAddressStyle = {
    marginTop: '20px'
};
const propertyState = [{ value: 'AL', ptype: 'Alabama' },
{ value: 'AK', ptype: 'Alaska' },
{ value: 'AZ', ptype: 'Arizona' },
{ value: 'AR', ptype: 'Arkansas' },
{ value: 'CA', ptype: 'California' },
{ value: 'CO', ptype: 'Colorado' },
{ value: 'CT', ptype: 'Connecticut' },
{ value: 'DE', ptype: 'Delaware' },
{ value: 'DC', ptype: 'District Of Columbia' },
{ value: 'FL', ptype: 'Florida' },
{ value: 'GA', ptype: 'Georgia' },
{ value: 'HI', ptype: 'Hawaii' },
{ value: 'ID', ptype: 'Idaho' },
{ value: 'IL', ptype: 'Illinois' },
{ value: 'IN', ptype: 'Indiana' },
{ value: 'IA', ptype: 'Iowa' },
{ value: 'KS', ptype: 'Kansas' },
{ value: 'KY', ptype: 'Kentucky' },
{ value: 'LA', ptype: 'Louisiana' },
{ value: 'ME', ptype: 'Maine' },
{ value: 'MD', ptype: 'Maryland' },
{ value: 'MA', ptype: 'Massachusetts' },
{ value: 'MI', ptype: 'Michigan' },
{ value: 'MN', ptype: 'Minnesota' },
{ value: 'MS', ptype: 'Mississippi' },
{ value: 'MO', ptype: 'Missouri' },
{ value: 'MT', ptype: 'Montana' },
{ value: 'NE', ptype: 'Nebraska' },
{ value: 'NV', ptype: 'Nevada' },
{ value: 'NH', ptype: 'New Hampshire' },
{ value: 'NJ', ptype: 'New Jersey' },
{ value: 'NM', ptype: 'New Mexico' },
{ value: 'NY', ptype: 'New York' },
{ value: 'NC', ptype: 'North Carolina' },
{ value: 'ND', ptype: 'North Dakota' },
{ value: 'OH', ptype: 'Ohio' },
{ value: 'OK', ptype: 'Oklahoma' },
{ value: 'OR', ptype: 'Oregon' },
{ value: 'PA', ptype: 'Pennsylvania' },
{ value: 'RI', ptype: 'Rhode Island' },
{ value: 'SC', ptype: 'South Carolina' },
{ value: 'SD', ptype: 'South Dakota' },
{ value: 'TN', ptype: 'Tennessee' },
{ value: 'TX', ptype: 'Texas' },
{ value: 'UT', ptype: 'Utah' },
{ value: 'VT', ptype: 'Vermont' },
{ value: 'VA', ptype: 'Virginia' },
{ value: 'WA', ptype: 'Washington' },
{ value: 'WV', ptype: 'West Virginia' },
{ value: 'WI', ptype: 'Wisconsin' },
{ value: 'WY', ptype: 'Wyoming' }];
const renderDropdownList = ({ input, data, valueField, textField }) =>
    <DropdownList {...input}
        data={data}
        valueField={valueField}
        textField={textField}
        defaultValue={"Select State"}
        onChange={input.onChange} />
class Address extends Component {
    state = { value: '' };
    
    renderInput = ({ input, meta, label, style, maxLength, mask }) => {
        const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
        return (
            <InputMask {...input} autoComplete="new-password" className={className} placeholder={label} style={style} 
            // maxLength={maxLength}
            mask={mask}
            />
        );
    }
    render() {
        return (
            <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-4">

                            <div className="form-row">
                                <div className="form-group col-12">
                                    <Field name="Address" component={this.renderInput} maxLength={75} label="Address"   />		
                                    <Field name="City" component={this.renderInput} maxLength={50} label="City" style={{ marginTop: '10px' }} />
                                </div>
                                <div className="form-group col-6 ">
                                    <Field
                                        name="State"
                                        component={renderDropdownList}
                                        data={propertyState}
                                        valueField="value"
                                        textField="ptype" />
                                </div>
                                <div className="col-6 form-group">
                                    <Field name="Zip" component={this.renderInput} label="Zip" 
                                    mask="99999"
                                    maxLength={5}/>
                                </div>
                            </div>

                        </div>
                        <div className="col-4">
                            <div className="form-row">
                                <div className="form-group col-12">
                                <Field name="LoanId" component={this.renderInput} label="Loan Id"   />	
                                </div>
                            </div>

                        </div>


                    </div>
                </div>

            </>
        );
    };
}
export default Address;